import * as actionTypes from "./actionTypes";

export const getApplicationNotes = (applicationId, callback = () => {}) => {
  console.log("getApplicationNotes action creator called with:", {
    applicationId,
    callback,
  });
  return {
    type: actionTypes.GET_APPLICATION_NOTES_REQUEST,
    applicationId,
    callback,
  };
};

export const getApplicationNotesSuccess = (notes) => ({
  type: actionTypes.GET_APPLICATION_NOTES_SUCCESS,
  notes,
});

export const getApplicationNotesError = (error) => ({
  type: actionTypes.GET_APPLICATION_NOTES_ERROR,
  error,
});

export const updateApplicationNotesReview = (
  noteId,
  reviewData,
  callback = () => {}
) => ({
  type: actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_REQUEST,
  noteId,
  reviewData,
  callback,
});

export const updateApplicationNotesReviewSuccess = (note) => ({
  type: actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_SUCCESS,
  note,
});

export const updateApplicationNotesReviewError = (error) => ({
  type: actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_ERROR,
  error,
});

export const clearApplicationNotesState = () => ({
  type: actionTypes.CLEAR_APPLICATION_NOTES_STATE,
});
